<template>
  <div
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
    ref="addKeywordsModal"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="addKeywords">
          <div class="modal-header">
            <h5 class="modal-title">新增關鍵字</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <input
              v-model="keywordsForm"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': invalid }"
              placeholder="請輸入關鍵字"
            />
            <div class="invalid-feedback" v-show="invalid">
              {{ invalid }}
            </div>
            <div class="form-text">
              多個輸入，請使用半型","做分隔，範例: "網頁,架站,設計,開發"
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" class="btn btn-primary">新增</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'KeywordsModal',
  props: ['keywords'],
  data () {
    return {
      bootstrap_modal: null,
      seo_keyword: null,
      keywordsForm: null,
      invalid: null
    }
  },
  computed: {
    ...mapState(['isShowKeywordsModal'])
  },
  watch: {
    isShowKeywordsModal (showState) {
      const vm = this
      if (vm.bootstrap_modal) {
        showState ? vm.bootstrap_modal.show() : vm.bootstrap_modal.hide()
      }
    }
  },
  methods: {
    ...mapMutations(['ToggleKeywordsModal']),
    addKeywords () {
      const vm = this
      const newArray = vm.keywordsForm.split(',')
      if (vm.keywords.length + newArray.length > 5) {
        vm.invalid = `關鍵字不可超過 5 項，目前可再新增 ${
          5 - vm.keywords.length
        } 項`
        return
      }
      vm.seo_keyword = vm.keywords.concat(newArray)
      vm.ToggleKeywordsModal(false)
      vm.$emit('setKeywords', vm.seo_keyword)
    }
  },
  mounted () {
    const vm = this
    const keywordsModalEl = vm.$refs.addKeywordsModal
    vm.bootstrap_modal = new Modal(keywordsModalEl, {
      backdrop: 'static',
      keyboard: false
    })

    keywordsModalEl.addEventListener('show.bs.modal', () => {
      vm.keywordsForm = null
      vm.invalid = null
    })

    keywordsModalEl.addEventListener('hidden.bs.modal', () => {
      vm.ToggleKeywordsModal(false)
    })
  }
}
</script>
